import { useUrlSearchParams } from '@dai/common'
import { useEffect, useState } from 'react'

export const useTabsWithParams = <Tab extends string>({
  TabMap,
  tabs,
}: {
  TabMap: Record<Tab, number>
  tabs: { key: Tab; label: string; component: React.ReactNode }[]
}) => {
  const TabArray = Object.entries<number>(TabMap)
    .sort((entry1, entry2) => entry1[1] - entry2[1])
    .map(([key]) => key as Tab)

  const {
    state: urlState,
    handle: { handleUpdateSearchParams },
  } = useUrlSearchParams<{ tab?: Tab }>()
  const { tab } = urlState

  const tabFromUrl: Tab = tab || TabArray[0]

  useEffect(() => {
    setValue(TabMap[tabFromUrl] || 0)
  }, [tabFromUrl])

  const [value, setValue] = useState(TabMap[tabFromUrl] || 0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
    handleUpdateSearchParams({ tab: TabArray[newValue] }, { replace: true })
  }

  const sortedTabs = tabs.sort((a, b) => TabMap[a.key] - TabMap[b.key])

  return {
    value,
    setValue,
    handleChange,
    sortedTabs,
  }
}
